import { Module, ActionContext } from 'vuex'
import { RootState, LocationSettingState } from './state_models'
import { ProductRebillingService } from '../services';
import { AuthUser } from '../models';
import { LOCATION_SETTING_CONFIG } from '../util/location_setting_config';

export const locationSetting: Module<LocationSettingState, RootState> = {
    namespaced: true,
    state: {},
    getters: {
		isAgencyProductEnabled: (state: LocationSettingState) => {
			return state.isAgencyProductEnabled
		}
    },
    mutations:{
        setAgencyProductEnabled(state,value) {
			state.isAgencyProductEnabled = value;
        }
    },
	actions:{
		async fetchAllProductOptInStatus(context: ActionContext<LocationSettingState, RootState>): Promise<LocationSettingState> {
			try {
				const credentials = new AuthUser(await context.dispatch('auth/get', null, { root: true }))
				const productKeys = Object.keys(LOCATION_SETTING_CONFIG)
				const res = await ProductRebillingService.get(credentials.companyId, 'COMPANY')
				const isAgencyProductEnabled = {}
				res.forEach(product => {
					if (productKeys.includes(product.type)) {
						isAgencyProductEnabled[product.type] = product.productOptIn;
					}
				});
				context.commit('setAgencyProductEnabled', isAgencyProductEnabled)
				return isAgencyProductEnabled 
			} catch (error) {
				console.error("Error fetching all product opt-in statuses:", error)
				return {}
			}
		},
	}
}